import {styled, Logo} from "@reside/ui";

export const NavLogo = styled(Logo)`
  width: 74.33px;
  height: 19px;
`;
